import { render, staticRenderFns } from "./CoopDetail.vue?vue&type=template&id=0353ecc7&scoped=true"
import script from "./CoopDetail.vue?vue&type=script&lang=js"
export * from "./CoopDetail.vue?vue&type=script&lang=js"
import style0 from "./CoopDetail.vue?vue&type=style&index=0&id=0353ecc7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0353ecc7",
  null
  
)

export default component.exports